import { graphql, type GraphQLTaggedNode } from 'react-relay';

/** @schema cc */
export const SpaceDetailFragment: GraphQLTaggedNode = graphql`
	fragment SpaceDetail_space on Space
	@argumentDefinitions(includeSpaceTypeSettings: { type: "Boolean!", defaultValue: false }) {
		id
		name
		alias
		key
		type
		dataClassificationTags
		homepage {
			id
			title
			type
		}
		icon {
			path
		}
		spaceTypeSettings @include(if: $includeSpaceTypeSettings) {
			enabledContentTypes {
				isLivePagesEnabled
				isWhiteboardsEnabled
				isDatabasesEnabled
				isSlidesEnabled
			}
		}
	}
`;
